import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, onRetry }) => {
  return (
    <div className="w-full max-w-2xl mx-auto">
      <div className="bg-red-50 border border-red-200 rounded-lg p-6">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <AlertCircle className="w-5 h-5 text-red-600 mt-0.5" />
          </div>
          
          <div className="flex-1 space-y-2">
            <h3 className="text-sm font-medium text-red-800">
              Analysis Failed
            </h3>
            <p className="text-sm text-red-700">
              {message}
            </p>
            
            {onRetry && (
              <button
                onClick={onRetry}
                className="mt-3 inline-flex items-center space-x-2 text-sm text-red-600 hover:text-red-800 font-medium"
              >
                <RefreshCw className="w-4 h-4" />
                <span>Try again</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
